module.exports = __webpack_public_path__ + "img/icon-garage.ff736917.svg";